import type { UpdateResolver } from '@urql/exchange-graphcache'
import type {
    DecisionDeletedSubscriptionVariables,
    DecisionUpdatedSubscriptionVariables,
} from '@/generated/gql/graphql'
import { invalidateCache } from '../utils/invalidateCache'

const cacheInvalidateUpdaters = {}
const cacheInvalidateMutationsList = ['editDecisionUnknownOldSpeakers']

cacheInvalidateMutationsList.forEach((mutation) => {
    cacheInvalidateUpdaters[mutation] = (result, args, cache) => {
        invalidateCache(cache, 'decision')
    }
})

export const decisionsMutationsUpdaters = {
    ...cacheInvalidateUpdaters,
}

export const decisionsSubscriptionsUpdaters: Record<string, UpdateResolver> = {
    decisionUpdated: (
        _result,
        args: DecisionUpdatedSubscriptionVariables,
        cache,
    ) => {
        cache.invalidate({
            __typename: 'Decision',
            id: args.decisionId,
        })
    },
    decisionDeleted: (
        _result,
        args: DecisionDeletedSubscriptionVariables,
        cache,
    ) => {
        cache.invalidate({
            __typename: 'Decision',
            id: args.decisionId,
        })
    },
}
